class RoutingResolver {

    constructor() {

    }

    feed() {
        throw new Error('Feed method must be implemented.');
    }
}

export default RoutingResolver
